<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      title="漫游（动画）"
      id="walkthroughAnimation"
      :close="walkthroughAnimationClose"
    >
      <template slot="content">
        <!-- <el-button type="primary" icon="el-icon-video-camera-solid" @click="play">
        开始
      </el-button> -->
        <div class="folding-steps">
          <div class="app-container">
            <el-steps
              direction="vertical"
              finish-status="success"
              :active="Number(activeNames)"
            >
              <el-step
                :title="i.stepTitle"
                class="step"
                v-for="i in stepList"
                :key="i.id"
              >
                <template slot="description">
                  <div class="description">
                    <div class="descriptionText">
                      <el-collapse
                        v-model="activeNames"
                        accordion
                        @change="handleChange"
                      >
                        <el-collapse-item title="" :name="i.name">
                          <template slot="title">
                            <i
                              v-if="
                                i.content.length > 0 && playState == 'start'
                              "
                              class="small-operation-btn el-icon-video-play"
                              @click.stop="play(i)"
                            ></i>
                            <i
                              v-if="
                                i.content.length > 0 && playState == 'pause'
                              "
                              class="small-operation-btn el-icon-video-pause"
                              @click.stop="pause"
                            >
                            </i>
                          </template>
                          <div>
                            <!-- {{ i.text }} -->
                            <ul
                              class="scene-walk-content"
                              v-if="i.content.length > 0"
                            >
                              <li
                                v-for="(item, index) in i.content"
                                :key="index"
                                @click="leap(item)"
                              >
                                <span class="mr-1">{{ index + 1 }}.</span>
                                <el-image
                                  class="mr-1-2"
                                  :src="item.url"
                                  fit="contain"
                                >
                                  <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                  </div>
                                </el-image>
                                <div class="operate">
                                  <time>标题：{{ item.text }}</time>
                                  <div class="operate-bottom">
                                    <i
                                      class="small-operation-btn el-icon-edit"
                                      @click="editViewpoint(item)"
                                    ></i>
                                    <i
                                      class="small-operation-btn el-icon-delete"
                                      @click.stop="deleteViewpoint(i, index)"
                                    ></i>
                                  </div>
                                </div>
                              </li>
                            </ul>
                            <p v-else>暂无数据</p>
                            <el-button
                              class="add-viewpoint"
                              @click="addViewpoint(i)"
                            >
                              <i class="el-icon-plus"></i> 添加视点</el-button
                            >
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>
      </template>
    </MapModal>
    <MapModal
      :modalNode="modalNodeEdit"
      :title="modalNodeState == 'add' ? '添加' : '编辑'"
      id="viewpointTourEdit"
      :close="viewpointTourEditClose"
      :submitData="submitData"
      :submit="onSubmit"
    >
    </MapModal>
  </div>
</template>
<script>
// import { EventBus } from "../../../static/js/event-bus.js";
const MapModal = () => import("@/components/common/mapModal/Index");
//按需加载
export default {
  name: "walkthrough-animation",
  props: {
    close: {
      type: Function,
    },
  },
  components: { MapModal },
  data() {
    return {
      modalNode: {
        viewpointTour: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -300,
            // unit: "px", // 默认px
          },
          width: "300px", // 宽度配置 默认450px
          height: `${
            document.querySelector("#mars3d-container").offsetHeight - 30
          }px`, // 配置模态框中心高度
          // height: "350px",
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      playState: "start",
      modalNodeState: "",
      modalNodeEditItem: null,
      modalNodeEdit: {
        viewpointTourEdit: {
          show: false, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 70,
            y: -620,
            // unit: "px", // 默认px
          },
          width: "300px", // 宽度配置 默认450px
          height: `370px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "form",
            formData: {
              url: {
                md: 24,
                type: "button",
                icon: "el-icon-camera",
                buttonTitle: "保存视角",
                click: this.screenshot,
              },
              text: {
                md: 24,
                type: "input",
                title: "视点标题",
                placeholder: "请填场景标题",
              },
              duration: {
                md: 24,
                type: "input",
                icon: "秒",
                title: "过渡时长",
                placeholder: "请填场景标题",
              },
              stop: {
                md: 24,
                type: "input",
                icon: "秒",
                title: "停留时间",
                placeholder: "请填场景标题",
              },
            },
            rules: {
              url: [
                {
                  required: true,
                  message: "请保存一个视点",
                  trigger: "blur",
                },
              ],
              text: [
                {
                  required: true,
                  message: "请填写标题",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      activeNames: 0,
      active: 0,
      stepList: [
        {
          name: "1",
          content: [
            {
              id: "1-1",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-1",
              alt: 925,
              heading: 96,
              lat: 26.101033,
              lng: 107.515071,
              pitch: -4,
              duration: 4,
              stop: 4,
            },
            {
              id: "1-2",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-2",
              alt: 925,
              heading: 79,
              lat: 26.101242,
              lng: 107.516796,
              pitch: -6,
              duration: 4,
              stop: 0,
            },
            {
              id: "1-3",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-3",
              alt: 951.6,
              heading: 80,
              lat: 26.101563,
              lng: 107.518159,
              pitch: -9,
              duration: 4,
              stop: 0,
            },
            {
              id: "1-4",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-4",
              alt: 951.6,
              heading: 82,
              lat: 26.102592,
              lng: 107.522075,
              pitch: -9,
              duration: 6,
              stop: 0,
            },
            {
              id: "1-5",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-5",
              alt: 945,
              heading: 82,
              lat: 26.10293,
              lng: 107.523624,
              pitch: -9,
              duration: 3,
              stop: 0,
            },
            {
              id: "1-6",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-6",
              lng: 107.526298,
              lat: 26.103611,
              alt: 945.2,
              heading: 82,
              pitch: -9,
              duration: 5,
              stop: 0,
            },
            {
              id: "1-7",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-7",
              lng: 107.526892,
              lat: 26.106057,
              alt: 980.7,
              heading: 161,
              pitch: -10,
              duration: 5,
              stop: 0,
            },
            {
              id: "1-8",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-8",
              lng: 107.527695,
              lat: 26.106227,
              alt: 980.7,
              heading: 161,
              pitch: -10,
              duration: 3,
              stop: 0,
            },
            {
              id: "1-9",
              url: "http://cdn.marsgis.cn/mars3d.cn/xm/jcxm/1.jpg",
              text: "视点1-9",
              lng: 107.527984,
              lat: 26.104265,
              alt: 1030.3,
              heading: 102, //方向
              pitch: -28, //俯仰角
              duration: 6,
              stop: 2,
            },
          ],
          stepTitle: "项目概况",
          id: 1,
          text: "第一条的内容",
        },
        {
          name: "2",
          content: [],
          stepTitle: "项目现状",
          id: 2,
          text: "第二条的内容",
        },
        {
          name: "3",
          content: [],
          stepTitle: "项目规范",
          id: 3,
          text: "第三条的内容",
        },
        {
          name: "4",
          content: [],
          stepTitle: "项目规划",
          id: 4,
          text: "第三条的内容",
        },
      ],
      submitData: {
        id: "",
        url: null,
        text: "",
        alt: 0,
        heading: 0,
        lat: 0,
        lng: 0,
        pitch: 0,
        duration: 0,
        stop: 0,
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    leap(item) {
      console.log(item);
      let { lng, lat, alt, heading, pitch } = item;
      this.$GLOBAL.map.centerAt({
        y: lat,
        x: lng,
        alt: alt,
        heading: heading,
        pitch: pitch,
      });
    },
    walkthroughAnimationClose() {
      this.close("pointView");
    },
    viewpointTourEditClose() {
      this.submitData = {
        id: "",
        url: null,
        text: "",
        alt: 0,
        heading: 0,
        lat: 0,
        lng: 0,
        pitch: 0,
        duration: 0,
        stop: 0,
      };
      this.modalNodeEdit.viewpointTourEdit.show = false;
    },
    play(item) {
      console.log(this.$GLOBAL.map.getCameraView());
      // this.playState = "pause";
      // const viewPoints = item.content;
      // viewPoints.forEach((item) => {
      //   console.log(item);
      //   item.onEnd = this.zhang;
      // });
      // // 视角切换（分步执行）
      // this.$GLOBAL.map.setCameraViewList(viewPoints, {
      //   complete: () => {
      //     console.log("漫游完成");
      //     this.playState = "start";
      //   },
      //   // endTransform: () => {
      //   //   console.log("guan");
      //   //   this.playState = "start";
      //   // },
      // });
    },
    pause() {
      this.playState = "start";
      this.$GLOBAL.map.cancelFlight();
    },
    // add 视角
    screenshot() {
      let { alt, heading, lat, lng, pitch } = this.$GLOBAL.map.getCameraView();
      this.$GLOBAL.map.expImage({
        download: false,
        width: 200,
        callback: (image) => {
          this.submitData.url = image;
          this.submitData.alt = alt;
          this.submitData.heading = heading;
          this.submitData.lat = lat;
          this.submitData.lng = lng;
          this.submitData.pitch = pitch;
        },
      });
    },

    addViewpoint(item) {
      this.modalNodeEditItem = item.content;
      this.modalNodeState = "add";
      this.modalNodeEdit.viewpointTourEdit.show = true;
    },

    editViewpoint(item) {
      this.modalNodeEditItem = item;
      this.submitData.url = item.url;
      this.submitData.text = item.text;
      this.submitData.duration = item.duration;
      this.submitData.stop = item.stop;
      this.submitData.alt = item.alt;
      this.submitData.heading = item.heading;
      this.submitData.lat = item.lat;
      this.submitData.lng = item.lng;
      this.submitData.pitch = item.pitch;
      this.modalNodeState = "edit";
      this.modalNodeEdit.viewpointTourEdit.show = true;
    },
    deleteViewpoint(item, index) {
      console.log(item, index);
      item.content.splice(index, 1);
    },
    handleChange() {},
    onSubmit() {
      if (this.modalNodeState == "edit") {
        let { alt, heading, lat, lng, pitch, url, text, duration, stop } =
          this.submitData;
        this.modalNodeEditItem.text = text;
        this.modalNodeEditItem.url = url;
        this.modalNodeEditItem.alt = alt;
        this.modalNodeEditItem.heading = heading;
        this.modalNodeEditItem.lat = lat;
        this.modalNodeEditItem.lng = lng;
        this.modalNodeEditItem.pitch = pitch;
        this.modalNodeEditItem.duration = duration;
        this.modalNodeEditItem.stop = stop;
      } else {
        let { alt, heading, lat, lng, pitch, url, text, duration, stop } =
          this.submitData;
        this.modalNodeEditItem.push({
          id: "new",
          text: text,
          url: url,
          alt: alt,
          heading: heading,
          lat: lat,
          lng: lng,
          pitch: pitch,
          duration: duration,
          stop: stop,
        });
      }
      this.$notify({
        title: "保存成功",
        message: "",
        type: "success",
        duration: 960,
        offset: 320,
      });
      this.viewpointTourEditClose();
    },
    init() {},
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.folding-steps {
  padding: 0 5px;
  margin: 20px 0 5px;
  width: 300px;
  .el-step {
    position: relative;
  }
  /deep/ .el-step__main {
    .el-step__title,
    .el-step.is-vertical .el-step__title {
      color: rgba(255, 255, 255, 0.9) !important;
      font-size: 16px;
      line-height: initial;
      padding-bottom: 20px;
      font-weight: inherit;
    }
    .el-collapse-item__header {
      border: 0;
    }
    .small-operation-btn {
      color: rgba(255, 255, 255, 0.9) !important;
      display: inline-block;
      position: absolute;
      right: 10%;
      font-size: 16px;
      &:hover {
        color: rgba(255, 255, 255, 1) !important;
      }
    }
    .el-icon-video-pause {
      // right: 18%;
    }
  }

  /deep/ .el-step__icon {
    border: 0;
    width: 20px;
    height: 20px;
    margin-left: 2px;
    .el-step__icon-inner {
      color: #565656 !important;
    }
    .el-step__icon-inner.is-status {
      color: #000 !important;
    }
  }

  /deep/ .descriptionText {
    .el-collapse-item__wrap {
      background-color: transparent;
      border: 0;
      margin-bottom: 10px;
    }
  }

  /deep/ .el-step.is-vertical .el-step__line {
    top: 2px;
  }

  /deep/.el-step__title.is-success {
    color: rgba(255, 255, 255, 1) !important;
    // padding-bottom: 10px;
  }
  /deep/.el-collapse {
    border: 0;
    .el-collapse-item__header {
      line-height: inherit;
      height: auto;
      background: transparent;
      position: absolute;
      top: 0;
      left: 10px;
      right: 20px;
      height: 26px;
      .el-collapse-item__arrow {
        color: #fff;
      }
    }
  }
  .el-collapse-item__wrap {
    border: 0;
    background: transparent;
    div {
      color: rgba(255, 255, 255, 0.9) !important;
    }
  }
  .scene-walk-content {
    padding: 0;
    list-style-type: none;
    li {
      display: flex;
      align-items: center;
      color: #ccc;
      height: 82px;
      cursor: pointer;
      /deep/ img {
        width: 110px;
        max-height: 72px;
        min-height: 30px;
      }
      .operate {
        height: 100%;
        width: 105px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .operate-bottom {
        display: flex;
        justify-content: end;
        margin-bottom: 5px;
        width: 100%;
        height: 14px;
        i {
          margin: 0 0 0 6px;
          font-size: 14px;
          position: relative;
          &:hover {
            color: #fff;
          }
        }
        // .el-icon-delete:hover {
        //   color: red;
        // }
      }
      &:hover {
        span,
        time {
          color: #fff;
        }
      }
    }
  }
  .add-viewpoint {
    background-color: transparent;
    color: #ccc;
    padding: 5px;
    width: 100%;
    border: 1px dashed #ccc;
    &:hover {
      background-color: #fff;
      color: #000;
      border: 1px solid #fff;
    }
  }
}
</style>
